import { IconBox, MetricIcon } from "@hightouch/htui";
import { SchemaIconProps } from "./types";

export const AdStatsIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return <IconBox color="blue" icon={<MetricIcon />} size={size} {...props} />;
};
